import axios from "axios";

export const getNextProjectNumber = async (instanceId) => {
  if (!instanceId) return null;

  const response = await axios.get(
    `${process.env.REACT_APP_NODEJS_SERVER_URL}/instances/${instanceId}/project-numbers/next`,
    { headers: { accessToken: localStorage.getItem("accessToken") } }
  );

  return response.data;
};
